import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const LocalLink = ({ to, children, ...props }: LinkProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || i18n.language || 'en';

  let localizedTo = to;
  if (typeof to === 'string' && to.startsWith('/')) {
    const supportedLngs = ['en', 'fr', 'ar'];
    const parts = to.split('/').filter(Boolean);
    
    // Avoid double prefixing
    if (supportedLngs.includes(parts[0])) {
      localizedTo = to;
    } else {
      // Ensure there's no double slash like /en//about
      const cleanTo = to === '/' ? '' : to;
      localizedTo = `/${lang}${cleanTo}`;
    }
  }

  return (
    <Link to={localizedTo} {...props}>
      {children}
    </Link>
  );
};
